import { takeLeading, select } from 'redux-saga/effects';
import { get, isNull } from 'lodash';
import { callApi } from 'helpers/saga-helpers';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { REQUEST_PREOPEN_BASIC_CLAIM } from 'containers/BasicManagement/redux/constants';

export function* preopenBasicClaim(action: any): Generator<unknown> {
  const { claimToPreOpen, successCallback } = action;
  const path = '/corporeal/common/preopen-basic-claim';

  const token = yield select(makeSelectKeycloakToken());

  if (isNull(token)) return;

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      name: get(currentUserStorage?.get(), 'username'),
    },
    body: JSON.stringify({
      ...claimToPreOpen,
      isLawyer: true,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}

export function* preopenBasicClaimSaga() {
  yield takeLeading(REQUEST_PREOPEN_BASIC_CLAIM, preopenBasicClaim);
}

export default [preopenBasicClaimSaga];
